export default async () => {
  const response = await fetch(`/wp-json/products/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const json = await response.json();
  return json;
};
